import Billing from '@web-solutions/module-billing';
import { init as initBilling } from 'core/store/billing/actions';
import { setApiAuth } from '@web-solutions/core/utils/network';
import { setAuthorized } from 'core/store/profile/actions';
import { useStore } from '../store/store';

type FoodzeeAuthPayload = {
  accessToken?: string;
  refreshToken?: string;
  access_token?: string;
  uid?: string;
  token?: string;
  userId?: number;
  stripeCustomerId?: string;
  user?: {
    uid?: string;
  };
  // Some endpoints (e.g. /profile/{id}/email) wrap the payload in `data`.
  data?: Omit<FoodzeeAuthPayload, 'data'>;
};

// Token may arrive as accessToken / token / access_token, optionally nested under `data`.
const extractAccessToken = (payload?: FoodzeeAuthPayload): string | undefined =>
  payload?.accessToken ||
  payload?.token ||
  payload?.access_token ||
  payload?.data?.accessToken ||
  payload?.data?.token ||
  payload?.data?.access_token;

type Options = {
  reinitBilling?: boolean;
  paymentSystem?: string;
  syncBillingAuth?: boolean;
};

const STRIPE_PAYMENT_SYSTEM = 'stripe';

export const applyFoodzeeAuthTokens = (
  payload: FoodzeeAuthPayload | undefined,
  dispatch?: any,
  options: Options = {},
) => {
  const accessToken = extractAccessToken(payload);

  if (!accessToken) {
    console.log('[applyFoodzeeAuthTokens] No accessToken found, returning false');
    return false;
  }

  console.log('[applyFoodzeeAuthTokens] Setting auth with token:', accessToken.substring(0, 10) + '...');
  const authHeader = `Bearer ${accessToken}`;
  const userId =
    payload?.uid || payload?.userId || payload?.user?.uid || payload?.data?.uid || payload?.data?.userId;
  const paymentSystem = options.paymentSystem || Billing.paymentSystemType;
  const shouldSyncBillingAuth = options.syncBillingAuth ?? paymentSystem === STRIPE_PAYMENT_SYSTEM;

  console.log('[applyFoodzeeAuthTokens] Setting auth tokens, userId:', userId, 'paymentSystem:', paymentSystem);

  useStore.getState().setAuthTokens({
    accessToken,
    refreshToken: payload?.refreshToken,
    userId,
  });

  if (!shouldSyncBillingAuth) {
    console.log('[applyFoodzeeAuthTokens] Not syncing billing auth');
    return false;
  }

  console.log('[applyFoodzeeAuthTokens] Syncing billing auth with header:', authHeader.substring(0, 20) + '...');
  Billing.setApiAuth(authHeader);
  setApiAuth(authHeader);

  if (dispatch) {
    console.log('[applyFoodzeeAuthTokens] Dispatching setAuthorized');
    dispatch(setAuthorized({
      token_type: 'Bearer',
      access_token: accessToken,
    }));

    if (options.reinitBilling) {
      console.log('[applyFoodzeeAuthTokens] Dispatching initBilling');
      return dispatch(initBilling());
    }
  }

  console.log('[applyFoodzeeAuthTokens] Returning true');
  return true;
};
